<div class="mobile-filter-button-container">
  <app-button
    [label]="'Filters'"
    [buttonStyle]="'outlined'"
    [icon]="''"
    (handleClick)="visible.set(true)"
    [fullWidth]="true"
  ></app-button>
  <div class="filter-button-icon"></div>
</div>

<p-drawer
  [(visible)]="visible"
  position="bottom"
  [style]="{ height: '600px' }"
  styleClass="mobile-filters-sidebar"
>
  <ng-template #header>
    <span class="filters-sidebar-title">Filters</span>
  </ng-template>

  <div class="mobile-filters-content">
    <div class="mb-4">
      <p-accordion [multiple]="false">
        <p-accordion-panel [value]="'1'">
          <p-accordion-header>
            <div class="flex align-items-center gap-2">
              <img
                src="assets/img/icons/filters/filters.svg"
                alt="filters"
                width="16"
                height="16"
              />
              <span>Categories</span>
            </div>
          </p-accordion-header>
          <p-accordion-content>
            <app-category-filter
              [(selectedCategoryIds)]="selectedCategoryIds"
              [leadCategoryId]="leadCategoryId()"
              (filtersChanged)="onFiltersChanged()"
            />
          </p-accordion-content>
        </p-accordion-panel>
      </p-accordion>
    </div>

    <div class="mb-4 sort-by-wrapper">
      <p-select
        [options]="sortingOptions()"
        [(ngModel)]="selectedSort"
        placeholder="Sort By"
        [style]="{ width: '100%' }"
        [showClear]="true"
        (onChange)="onFiltersChanged()"
      ></p-select>
      <img
        src="assets/img/icons/filters/sort.svg"
        alt="sort"
        class="sort-icon-inside"
        width="16"
        height="16"
      />
    </div>

    <div class="grid">
      <div class="col-6">
        <app-button
          [label]="'Clear Filters'"
          [buttonStyle]="'outlined'"
          (handleClick)="onClearFilters()"
          [fullWidth]="true"
        ></app-button>
      </div>
      <div class="col-6">
        <app-button
          [label]="'See Results'"
          [buttonStyle]="'primary'"
          (handleClick)="onApplyFilters()"
          [fullWidth]="true"
        ></app-button>
      </div>
    </div>
  </div>
</p-drawer>
